// App.js
import React, { useEffect } from "react";
import ReactPixel from 'react-facebook-pixel';
import ScrollToTop from "./ScrollToTop";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import './App.css';
import Blog from './Blog';
import VideoEditingTips from './blog-posts/3VideoEditingTips';
import Navbar from "./Navbar";
import Homepage from "./Homepage";
import Work from "./Work";
import Packages from "./Packages";
import About from './About';
import Contact from './Contact';
import GetMatched from './GetMatched';
import RigendFilm1 from "./blog-posts/RigendFilm_1";
import Thanks from "./Thanks"; 

// Wrapper component to handle Pixel page views
function PixelTracker({ children }) {
  const location = useLocation();

  useEffect(() => {
    // Initialize Pixel once
    ReactPixel.init('288470515016619'); // replace with your Pixel ID
  }, []);

  useEffect(() => {
    // Track page view on route change
    ReactPixel.pageView();
  }, [location.pathname]);

  return children;
}

function App() {
  return (
    <BrowserRouter>
      <PixelTracker>
        <Navbar />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/work" element={<Work />} />
          <Route path="/packages" element={<Packages/>} />
          <Route path="/about" element={<About />} />
          <Route path="/thanks" element={<Thanks />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/get-matched" element={<GetMatched />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/video-editing-workflow-tips" element={<VideoEditingTips />} />
          <Route path="/blog/rigend-film-case-study" element={<RigendFilm1 />} />
        </Routes>
      </PixelTracker>
    </BrowserRouter>
  );
}

export default App;
